"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messagesColorPalettes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
exports.messagesColorPalettes = {
    success: {
        base: '#2dd36f',
        shade: '#28ba62',
        tint: '#d6ffe6',
    },
    error: {
        base: '#eb445a',
        shade: '#cf3c4f',
        tint: '#ffd6db',
    },
    warning: {
        base: '#ffc409',
        shade: '#e0ac08',
        tint: '#fff5d6',
    },
    info: {
        base: '#5f5f5f',
        shade: '#545454',
        tint: '#ebebeb',
    },
};
function Message(props) {
    const { style = {}, type, children } = props;
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            padding: '0.375rem 0.75rem',
            borderRadius: '0.25rem',
            backgroundColor: exports.messagesColorPalettes[type].tint,
            color: exports.messagesColorPalettes[type].shade,
            ...style,
        }, children: children }));
}
exports.default = Message;
